type Props = {
  totalEarned: number
  totalSold: number
}

const UserEarningsCard: React.FC<Props> = ({ totalEarned, totalSold }) => {
  const getNextPayoutDate = () => {
    const today = new Date()
    const day = today.getDate()
    const next = new Date(today)

    if (day < 1) {
      next.setDate(1)
    } else if (day < 15) {
      next.setDate(15)
    } else {
      next.setMonth(today.getMonth() + 1)
      next.setDate(1)
    }

    return next.toLocaleDateString('pt-BR')
  }

  return (
    <>
      <div className="p-6 bg-green-100 border border-green-400 text-green-900 rounded-2xl shadow-md max-w-md w-full mx-auto mt-6">
        <h2 className="text-xl font-semibold mb-4">Resumo de reservas</h2>
        <div className="mb-4">
          <p className="text-3xl font-bold">R$ {totalEarned.toFixed(2)}</p>
          <p className="text-sm text-gray-600">Total de investimento do cliente (5% descontado)</p>
        </div>
        <div>
          <p className="text-xl font-medium">{totalSold} (reserva aguardando)</p>
          <p className="text-sm text-gray-600">Não inclui taxas de transações</p>
        </div>
      </div>

      <div className="w-full max-w-md p-6 bg-white shadow-xl rounded-2xl border border-gray-200 mt-6">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">💰 Minhas contas</h2>
        <div className="mb-4">
          <p className="text-lg text-gray-700">
            💵 <span className="font-semibold">Total pago:</span> R${" "}
            {totalEarned.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}
          </p>
          <p className="text-lg text-gray-700 mt-2">
            📈 <span className="font-semibold">Shows vendidos:</span> {totalSold}
          </p>
        </div>
        <div className="mt-6 text-sm text-gray-600 italic">
          Os pagamentos são realizados nos dias <span className="font-semibold">1</span> e{" "}
          <span className="font-semibold">15</span> de cada mês. Confira seus ganhos abaixo.
        </div>
        <div className="mt-2 text-sm text-gray-600">
          Próximo pagamento: <span className="font-semibold">{getNextPayoutDate()}</span>
        </div>
      </div>
    </>
  )
}

export default UserEarningsCard
